import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { IState } from '../../../../store';
import { closeBanner } from '../../actions';
import { bannerCard, trackCloseStalkerBanner } from '../../utils/tracking';
import { CloseIcon } from './CloseIcon';

export const CloseIconContainer = connect(
  undefined,
  (dispatch: Dispatch<IState>) => ({
    onClick: bindActionCreators(closeBanner, dispatch),
  }),
  (storeProps, dispatchProps) => ({
    onClick() {
      trackCloseStalkerBanner(bannerCard);
      dispatchProps.onClick();
    },
  }),
)(CloseIcon);
